import { BadgeCheck, Building2, Star, ShieldCheck, Stars } from "lucide-react";
import { Reveal } from "./reveal";

const CHAMBER_URL =
  "https://business.bethlehemchamber.com/list/member/capital-pro-pressure-washing-5723";

const BADGES: Array<{
  icon: typeof BadgeCheck;
  label: string;
  sub: string;
  href?: string;
}> = [
  {
    icon: BadgeCheck,
    label: "Google Guaranteed",
    sub: "Screened & verified by Google",
  },
  {
    icon: Building2,
    label: "Chamber Member",
    sub: "Bethlehem Chamber of Commerce",
    href: CHAMBER_URL,
  },
  {
    icon: Star,
    label: "Veteran Owned",
    sub: "US Army owned & operated",
  },
  {
    icon: ShieldCheck,
    label: "Fully Insured",
    sub: "Workers comp & liability",
  },
  {
    icon: Stars,
    label: "90+ Five-Star Reviews",
    sub: "From Capital Region homeowners",
  },
];

export function HomeTrustBadges() {
  return (
    <section className="bg-white py-14 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4">
        <div className="text-center mb-9 md:mb-11">
          <p
            className="text-[var(--brand-red)] font-semibold uppercase tracking-[0.2em] text-sm mb-3"
            style={{ fontFamily: "var(--font-display)" }}
          >
            Credentials
          </p>
          <h2
            className="text-[var(--brand-deep-blue)] text-3xl md:text-4xl uppercase leading-tight"
            style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
          >
            Trust Your Home to the Pros
          </h2>
        </div>

        <ul className="grid grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {BADGES.map(({ icon: Icon, label, sub, href }, i) => {
            const inner = (
              <>
                <Icon
                  className="text-[var(--brand-red)] mb-3"
                  size={34}
                  strokeWidth={1.9}
                  aria-hidden="true"
                />
                <span
                  className="text-[var(--brand-deep-blue)] text-sm md:text-base uppercase leading-tight"
                  style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
                >
                  {label}
                </span>
                <span className="mt-1 text-[var(--brand-charcoal)]/75 text-xs leading-snug">
                  {sub}
                </span>
              </>
            );
            return (
              <Reveal
                as="li"
                key={label}
                delayMs={i * 70}

                className="card-pop flex h-full flex-col items-center text-center bg-[var(--brand-light-gray)] border border-gray-200 rounded-lg p-5"
              >
                {href ? (
                  <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex h-full flex-col items-center text-center"
                  >
                    {inner}
                  </a>
                ) : (
                  inner
                )}
              </Reveal>
            );
          })}
        </ul>

        <Reveal className="mt-10 rounded-lg bg-[var(--brand-deep-blue)] px-6 py-8 md:py-9 flex flex-col md:flex-row items-center gap-6 text-center md:text-left">
          <div
            className="shrink-0 w-28 h-28 rounded-full border-4 border-[var(--brand-red)] bg-white flex flex-col items-center justify-center px-2"
            aria-hidden="true"
          >
            <span
              className="text-[var(--brand-deep-blue)] text-2xl leading-none"
              style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
            >
              100%
            </span>
            <span
              className="mt-1 text-[var(--brand-red)] text-[10px] uppercase tracking-[0.14em] leading-tight"
              style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
            >
              Satisfaction
              <br />
              Guarantee
            </span>
          </div>
          <div>
            <h3
              className="text-white text-2xl md:text-3xl uppercase leading-tight"
              style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
            >
              Your Satisfaction, Guaranteed
            </h3>
            <p className="mt-3 text-white/90 text-base leading-relaxed max-w-2xl">
              If you're not happy with a surface we cleaned, tell us and we come back and
              re-treat it. No arguing, no runaround. We've been doing this in the Capital
              Region for 10 years and our name is on every job.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}